// This is a map of router slugs to their statically analyzable tagged
// localize template strings, so that the rest of the codebase can
// succinctly express i18n router links.
export const routerLinkSlugs: Record<string, string> = {
  ['/after-school']: $localize`:@@//after-school:/after-school`,
  ['/cart']: $localize`:@@//cart:/cart`,
  ['/cart/add/course']: $localize`:@@//cart/add/course:/cart/add/course`,
  ['/cart/add/workshop']: $localize`:@@//cart/add/workshop:/cart/add/workshop`,
  ['/checkout/result']: $localize`:@@//checkout/result:/checkout/result`,
  ['/contact-us']: $localize`:@@//contact-us:/contact-us`,
  ['/courses']: $localize`:@@//courses:/courses`,
  ['/custom-camps']: $localize`:@@//custom-camps:/custom-camps`,
  ['/faq']: $localize`:@@//faq:/faq`,
  ['/integrity']: $localize`:@@//integrity:/integrity`,
  ['/profile']: $localize`:@@//profile:/profile`,
  ['/profile/my-registrations']: $localize`:@@//profile/my-registrations:/profile/my-registrations`,
  ['/report']: $localize`:@@//report:/report`,
  ['/skillz-team']: $localize`:@@//skillz-team:/skillz-team`,
  ['/workshops']: $localize`:@@//workshops:/workshops`,
  ['add']: $localize`:@@/add:add`,
  ['cart']: $localize`:@@/cart:cart`,
  ['course']: $localize`:@@/course:course`,
  ['workshop']: $localize`:@@/workshop:workshop`,
};
